<template>
  <div id="pk_box" @click="close_web">
    <div class="main_con" @click.stop>
      <p class="top_tit">团战玩法介绍</p>
      <div class="scroll_box">
        <p class="p_top">激情团战是什么？</p>
        <p class="p_p1">
          激情团战是朱贝电台直播的一种玩法，你可以选择加入蓝队或红队，你收到的礼物代表你的魅力值，团队总魅力值较高的一方为获胜队伍。
        </p>
        <p class="p_con">1.MVP和首席爱神</p>
        <p class="p_p1">
          激情团战开始后，玩家个人魅力值一旦达到5000即可成为全场唯一的MVP，后续MVP的获得者以全场最高魅力值玩家为准。
        </p>
        <div class="img_con">
          <img
            class="imgBlock noevents-img"
            src="../../assets/hourtext/tuanimg.png"
          />
        </div>
        <p class="p_p1">
          当个人贡献值达到2000，即可荣登“首席爱神”宝座，后续首席爱神宝座获得者以全场个人贡献值最高为准。
        </p>
        <div class="img_con">
          <img
            class="imgBlock noevents-img"
            src="../../assets/hourtext/tz02.png"
          />
        </div>

        <p class="p_con pad_top">2.礼物收益</p>
        <div class="bot_text flex-box">
          <div>
            上麦玩家收到的礼物将兑换成珍珠存入个人<span>【朱贝 钱包】</span>中。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>








<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$tool.setTitle("团战玩法介绍");
    this.$appAc.app_refreshUsable(0); //阻止安卓的刷新
  },
  methods: {
    /**关闭webview */
    close_web() {
      this.$appAc.closeWeb();
    },
  },
};
</script>









<style scoped>
#pk_box {
  width: 100%;
  min-height: 100vh;
  background: none;
}

.main_con {
  width: 100%;
  padding: 0 20px 0 20px;
  background-color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  min-height: 68vh;
}
.top_tit {
  width: 100%;
  text-align: center;
  font-size: 15px;
  color: #333;
  padding: 16px 0;
  background-color: #fff;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 3;
}

.scroll_box {
  /* height: calc(68vh - 52px); */
  overflow-y: scroll;
}
.p_top {
  font-size: 1.0625rem;
  font-weight: bold;
  color: #333;
}
.p_con {
  font-size: 1.0625rem;
  font-weight: bold;
  color: #666;
}
.p_p1 {
  padding: 15px 0;
  font-size: 0.9375rem;
  color: #666;
  line-height: 1.5;
}
.img_con {
  width: 90%;
  margin: 0 auto;
}
.bot_text {
  font-size: 15px;
  color: #666;
  padding: 16px 0 50px;
}
.bot_text span {
  font-weight: bold;
}
.pad_top {
  padding-top: 16px;
}
</style>